export type IAgFormTenthSectionInterface = {
    Signature?: string,
    SignatureDate?: string
}

export const AgFormTenthSectionInitialState = (): IAgFormTenthSectionInterface => ({
    Signature: undefined,
    SignatureDate: undefined
})